/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { InfluencerListItemViewModelPaginatedResponse } from "../types/InfluencerListItemViewModelPaginatedResponse.ts";
import { influencerListItemViewModelSchema } from "./influencerListItemViewModelSchema.ts";

export const influencerListItemViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => influencerListItemViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<InfluencerListItemViewModelPaginatedResponse>;
